import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify';
import { fetchLogin, outhService } from '../../utilities/partnerServices';

export const fetchUserLogin = createAsyncThunk(
    'users/fetchUserLogin', fetchLogin
)
export const ouathServiceApi = createAsyncThunk(
    'users/outhServiceApi', outhService
)

const initialState = {
    loader: false,
    access_token:'',
    refresh_token:'',
    userID:'',
    Email:'',
    value: {
        EmailAddress: "--",
        PortalUserID: "--",
        EIN:'--',
        PortalType: "",
    },
    isLoggedin: false,
    isPreviousSessionActive: false,
    FirstName: "",
    LastName: "",
    PhoneNumber: "",
    rememberMeFlag:false,
    CaseMgtUserID: ""
}

const loginSlice = createSlice({
    name: 'login',
    initialState,

    reducers: {
        resetLogin: (state) => {
            // toast.success("login reseted Successfully")
            state.value = {
                EmailAddress: "--",
                PortalUserID: "--",
                UserType: "--",
                ProviderID: "--",
                FirstName: "--",
                LastName: "--",
                NPI: "--"
            }
            state.isLoggedin = false
            state.isPreviousSessionActive = false
            state.FirstName = ""
            state.LastName = ""
            state.PhoneNumber = ""
            state.rememberMeFlag = false
            state.CaseMgtUserID = ""
        },
        updateLogin: (state, action) => {
            state.value.EmailAddress = action.payload.EmailAddress;
            state.value.EIN = action.payload.EIN;
            state.value.PortalUserID = action.payload.PortalUserID;
            state.value.PortalType = action.payload.PortalType;
            state.FirstName = action.payload.FirstName;
            state.LastName = action.payload.LastName;
            state.PhoneNumber = action.payload.PhoneNumber;
            state.CaseMgtUserID = action.payload.CaseMgtUserID;
        },
        loginPortalDetails: (state, action) => {
            const res = action?.paylosd
            state.loader = false
            state.value = {
                EmailAddress: res?.EmailAddress || "--",
                PortalUserID: res?.PortalID || "--",
                EIN: res?.EINNumber || '--',
                PortalType: res?.PortalType || "",
            }
            state.FirstName = res?.UserFirstName || ""
            state.LastName = res?.UserLastName || ""
            state.PhoneNumber = res?.PhoneNumber || ""
        },
        Email: (state, action) => {
            state.Email = action.payload;
        },
        updateIsLoggedin: (state, action) => {
            state.isLoggedin = action.payload
        },
        updateUserId: (state, action) => {
            state.userID = action.payload
        },
        resetPrevSession: (state, action) => {
            state.isPreviousSessionActive = action.payload

        },
        loginLoader:(state,action)=>{
            state.loader = action.payload
        },
        updateRememberMeFlag:(state,action)=>{
            state.rememberMeFlag = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserLogin.pending, (state, action) => {
                state.loader = true
            })
            .addCase(fetchUserLogin.fulfilled, (state, action) => {
                let response = action.payload;
                if (response?.ResponseDetails?.ResponseCode == "010") { // Success case
                    state.value.EmailAddress = response?.PartnerPortalUser?.EmailAddress || '--';
                    state.value.EIN = response?.PartnerPortalUser?.EINNumber || '--';
                    state.value.PortalUserID = response?.PartnerPortalUser?.PortalUserID || '--';
                    state.FirstName = response?.PartnerPortalUser?.UserFirstName || ""
                    state.LastName = response?.PartnerPortalUser?.UserLastName || ""
                    state.PhoneNumber = response?.Partner?.AdditionalProviderAddress[0]?.PhoneNumber || ""
                    state.isLoggedin = true
                    toast.success("Login Successful")
                } else if (response?.ResponseDetails?.ResponseCode == "B004") { // Previous active session
                    state.isPreviousSessionActive = true
                    // toast.warn(action.payload.ResponseDetails.ResponseMessage)
                } else if (response?.ResponseDetails?.ResponseCode == "B010") { // User account locked for 5 failure attempts
                    toast.error(action.payload.ResponseDetails.ResponseMessage)
                } else { // General error message
                    toast.error("Username or Password Invalid. Please ensure you have registered and correctly entered your Username and Password");
                }
                state.loader = false
            })
            .addCase(fetchUserLogin.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
            .addCase(ouathServiceApi.pending, (state, action) => {
                // toast.warn("login pending")
            })
            .addCase(ouathServiceApi.fulfilled, (state, action) => {
                let response = action.payload
                state.access_token = response.access_token
                state.refresh_token = response.refresh_token

                // toast.success(action.payload.ResponseDetails.ResponseMessage)
            })
            .addCase(ouathServiceApi.rejected, (state, action) => {
                toast.error(action.error.message)
            })
    },
})

export const { resetLogin, resetPrevSession, updateLogin, updateIsLoggedin, Email, updateUserId, loginPortalDetails, loginLoader, updateRememberMeFlag } = loginSlice.actions
export const login = state => state.loginSlice.isLoggedin

export default loginSlice.reducer
